import React, { useEffect, useRef } from 'react'

import { List, ListItem } from '@mui/material'
import useInnovaTheme from './hooks/useInnovaTheme'

const SimpleStyledList = ({ listItems, renderItem, listSx, itemSx }) => {
  const _isMounted = useRef(false)
  const { getLinearGradient } = useInnovaTheme()

  useEffect(() => {
    _isMounted.current = true
    return () => {
      _isMounted.current = false
    }
  }, [])

  return (
    <List
      dense
      sx={{
        width: '100%',
        backgroundColor: (theme) => theme.palette.itemBackground,
        overflow: 'auto',
        position: 'relative',
        '&::-webkit-scrollbar': {
          width: '10px',
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
          WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#136cb9',
          outline: '1px solid #1679d0',
        },
        ...listSx,
      }}>
      {listItems?.map((item, index) => (
        <ListItem
          dense
          disableGutters={true}
          key={`${index}`}
          sx={{
            padding: '0px',
            borderRadius: 5,
            border: '1px solid',
            marginLeft: '8px',
            background: getLinearGradient(),
            marginBottom: '4px',
            width: 'calc(100% - 10px)', // 8px for marginLeft, 2px for left & right border
            ...itemSx,
          }}>
          {renderItem(item, index)}
        </ListItem>
      ))}
    </List>
  )
}

export default SimpleStyledList
